import { Immutable } from "immer";
import React from "react";

import type { OfferBannerBlock as Value } from "@reactivated";

import { RichTextBlock } from "@thelabnyc/thelabui/src/components/RichText";
import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import { getSpacingClasses } from "../spacing";

import styles from "./index.module.scss";

type Props = Immutable<{
    value: Value;
}>;

const barLineTypeClasses = {
    white: styles.offerBannerBlockBarWhite,
    razzmatazz: styles.offerBannerBlockBarRazzmatazz,
};

export const OfferBannerBlock = (props: Props): React.JSX.Element => {
    const v = props.value;
    return (
        // The outer div also carries the spacing sub-block classes (space-separated). With no spacing configured
        // getSpacingClasses returns "" so only the module class is emitted.
        <div
            className={concatClassNames([
                styles.offerBannerBlock,
                getSpacingClasses(v.spacing),
            ])}
        >
            <div className="l-full-width">
                <div className={styles.offerBannerBlockContent}>
                    {/* Legacy `<div class="rich-text">{{ self.copy }}</div>`.
                        `copy` is a ClientRenderingBarrier RichTextBlock, so its
                        serialized value is the SERVER-rendered HTML string,
                        which Wagtail wraps in its own `<div class="rich-text">`.
                        Passing className="rich-text" to RichTextBlock emits the
                        explicit outer `.rich-text` wrapper; its innerHTML is the
                        serialized string (containing the inner `.rich-text`
                        div) — reproducing the legacy's two nested wrappers. */}
                    <RichTextBlock className="rich-text" value={v.copy ?? ""} />
                    <div
                        className={concatClassNames([
                            styles.offerBannerBlockBar,
                            v.line_type
                                ? barLineTypeClasses[v.line_type]
                                : null,
                        ])}
                    />
                </div>
            </div>
        </div>
    );
};
